<div class="left" (click)="goToCenter()" *ngIf="currentTab === 3">
  <span>{{ "presentation" | translate }}</span>
  <i class="fas fa-chevron-left"></i>
</div>
<div class="row d-flex justify-content-center">
  <h1 class="text-center mt-3">{{ "galery" | translate }}</h1>
  <div class="row">
    <div class="col-12 mt-3">
      <br />
      <!-- <app-gallery-company
        [galleryList]="galleryCompanyList"
        *ngIf="galleryCompanyList.length > 0"
      ></app-gallery-company> -->
      <br />
      <app-gallery [galleryList]="galleryList"></app-gallery>
    </div>
  </div>

  <!-- <div class="row d-flex justify-content-center">
    <div class="col-10 mt-5">
      <carousel
        [isAnimated]="true"
        [showIndicators]="false"
        [interval]="10000"
        *ngIf="galleryList.length !== 0"
      >
        <slide *ngFor="let item of galleryList; let index = index">
          <div
            class="container-image"
            *ngIf="typeService(item.urlFile) === 'image'"
          >
            <img [src]="buildUrlGallery(item)" class="image-gallery" />
          </div>

          <div
            class="container-video"
            *ngIf="typeService(item.urlFile) === 'video'"
          >
            <video class="d-block w-100" controls style="background: black">
              <source [src]="buildUrlGallery(item)" type="video/mp4" />
            </video>
          </div>
        </slide>
      </carousel>

      <carousel
        [isAnimated]="true"
        [showIndicators]="false"
        [interval]="10000"
        *ngIf="galleryList.length === 0"
      >
        <slide>
          <div class="container-image">
            <img
              src="../../../../../assets/img/carousel1.jpg"
              class="image-gallery"
            />
          </div>
        </slide>
        <slide>
          <div class="container-image">
            <img
              src="../../../../../assets/img/carousel2.jpg"
              class="image-gallery"
            />
          </div>
        </slide>
        <slide>
          <div class="container-image">
            <img
              src="../../../../../assets/img/carousel3.jpg"
              class="image-gallery"
            />
          </div>
        </slide>
      </carousel>
    </div>
  </div> -->
</div>
<div class="row mt-5">
  <div class="col-12 text-center">
    <h1>{{ "services" | translate }}</h1>
    <!--<div class="servicios">
      <div class="servicio">
        <img
          src="https://tarjetasf.virtualplace.online/fotosPortada/114/11262021103637AM114_B.jpg?nocache=0.6211728250716673"
        />
        <div class="servicio-detalles">
          <h3>Titulo</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi,
            similique!
          </p>
        </div>
      </div>
      <div class="servicio">
        <img
          src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/4273/sophie.jpg"
        />
        <div class="servicio-detalles">
          <h3>Titulo</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi,
            similique!
          </p>
        </div>
      </div>
    </div> -->

    <div class="services" *ngFor="let item of servicesCompanyList; let index = index">
      <a target="_blank" [href]="urlServiceCompany(index)">
        <div class="box">
          <p [ngClass]="{ 'span-image': !typeServiceImage(imageServiceCompany(index)) }" >
            {{ item.nombreServicio }}
          </p>
          <img [src]="imageServiceCompany(index)" [ngClass]="{ svg: typeServiceImage(imageServiceCompany(index)), 'image-service': !typeServiceImage(imageServiceCompany(index))}"
          />
        </div>
      </a>
    </div>

    <div class="services" *ngFor="let item of servicesList; let index = index">
      <a target="_blank" [href]="urlService(index)">
        <div class="box">
          <p [ngClass]="{ 'span-image': !typeServiceImage(imageService(index)) }" >
            {{ item.nombreServicio }}
          </p>
          <img [src]="imageService(index)" [ngClass]="{ svg: typeServiceImage(imageService(index)), 'image-service': !typeServiceImage(imageService(index))}"/>
        </div>
      </a>
    </div>
  </div>
</div>
